import { getRequestsExtraInfo } from '../../../../api'
import { createSearchArray } from '../../../../utils/api'
import {
  getBirdviewRequests,
  getBirdviewRequestsCount,
} from '../../DashboardBirdview.api'

import { toBirdviewRequestItem } from './useBirdviewRequestLoaders.utils'

export function useBirdviewRequestLoaders() {
  // TODO The count endpoint carries no trend: return `delta` ({ direction,
  // text }) and `deltaTone` next to the count once the backend ships the
  // period delta the tiles show in the prototype.
  async function getRequestsCountTile(filters) {
    const { data } = await getBirdviewRequestsCount(filters)

    return { count: data.total }
  }

  // Tags are decoration: an enrichment failure must not hide the rows that
  // loaded.
  async function getRequestsExtra(items) {
    if (items.length === 0) {
      return null
    }

    try {
      const { data } = await getRequestsExtraInfo(
        createSearchArray('id', items)
      )

      return data
    } catch {
      return null
    }
  }

  // The request list page carries no total, so the count endpoint rides along,
  // as in useTableLoader.
  async function getRequestsSection(filters, toItem = toBirdviewRequestItem) {
    const [{ data }, { data: count }] = await Promise.all([
      getBirdviewRequests(filters),
      getBirdviewRequestsCount(filters),
    ])

    return {
      extra: await getRequestsExtra(data.items),
      items: data.items.map(toItem),
      total: count.total,
    }
  }

  return { getRequestsCountTile, getRequestsSection }
}
